import {toast} from 'react-toastify';

export const SUCCESS_MANAGER_EVENTS = {
  EMAIL_CLICKED: 'csm_email_clicked',
  EMAIL_COPIED: 'csm_email_copied'
};

export const SUCCESS_MANAGER_SOURCES = {
  SIDEBAR: 'sidebar',
  HELP_PAGE: 'help_page'
};

export const getFullName = (manager) =>
  [manager?.firstName, manager?.lastName].filter(Boolean).join(' ');

export const getInitials = (manager) =>
  [manager?.firstName, manager?.lastName]
    .filter(Boolean)
    .map((name) => name.charAt(0))
    .join('')
    .toUpperCase();

export const getMailto = (manager) => `mailto:${manager.email}`;

export const trackEmailClicked = (source) =>
  window?.posthog?.capture(SUCCESS_MANAGER_EVENTS.EMAIL_CLICKED, {source});

// Returns true when the email reached the clipboard.
export const copyEmail = async (manager, source) => {
  if (!navigator.clipboard) {
    toast.error('Copy is not available in this browser');
    return false;
  }
  try {
    await navigator.clipboard.writeText(manager.email);
  } catch {
    toast.error('Could not copy the email');
    return false;
  }
  window?.posthog?.capture(SUCCESS_MANAGER_EVENTS.EMAIL_COPIED, {source});
  return true;
};
